import { useTranslation } from 'react-i18next';
import FileUpload from 'src/pages/Devices/GroupDetails/TabPages/GroupDesign/components/FileUpload';
import { FileData } from 'src/pages/Devices/GroupDetails/TabPages/GroupDesign/components/FileUpload/FileUpload';

interface AssetUploadPanelProps {
  value: FileData | null;
  onChange: (fileData: FileData | null) => void;
  accept?: string;
  maxSizeInMB?: number;
  minWidth?: number;
  minHeight?: number;
  onValidateFile?: (fileData: FileData) => boolean;
}

export const AssetUploadPanel = ({
  value,
  onChange,
  accept,
  maxSizeInMB,
  minWidth,
  minHeight,
  onValidateFile,
}: AssetUploadPanelProps) => {
  const { t } = useTranslation();

  return (
    <FileUpload
      accept={accept}
      maxSizeInMB={maxSizeInMB}
      minWidth={minWidth}
      minHeight={minHeight}
      label={t('assets.clickOrDragFileToThisAreaToUpload')}
      value={value ?? undefined}
      onValidateFile={onValidateFile}
      onChange={(fileData) => onChange(typeof fileData === 'string' ? { url: fileData, image: fileData } : fileData)}
    />
  );
};
